/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 16,
    height: 16,
    viewBox: '0 0 200 130',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M195 0H5a5 5 0 100 10h190a5 5 0 100-10zM195 60H5a5 5 0 100 10h190a5 5 0 100-10zM195 120H5a5 5 0 100 10h190a5 5 0 100-10z"/></g></g>'
  }
})
